// extracted by mini-css-extract-plugin
export var container = "_49-0";
export var disabled = "_49-4";
export var fullWidth = "_49-3";
export var lined = "_49-1";
export var selected = "_49-5";
export var tab = "_49-2";